import $ from 'jquery';
import $script from 'scriptjs';
import ShopifySectionsManager from 'shopify-sections-manager';
import PxsMap from 'pxs-map';
import 'intersection-observer';
import rimg from 'rimg-shopify';

import './utils/jquery';

// Templates
import TemplateAccountAddresses from './templates/TemplateAccountAddresses';
import TemplateAccountLogin from './templates/TemplateAccountLogin';
import TemplateGiftCard from './templates/TemplateGiftCard';
import TemplatePassword from './templates/TemplatePassword';

// Sections
import DynamicBlog from './sections/DynamicBlog';
import DynamicCollection from './sections/DynamicCollection';
import DynamicInstagram from './sections/DynamicInstagram';
import DynamicProduct from './sections/DynamicProduct';
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicTwitter from './sections/DynamicTwitter';
import DynamicVideo from './sections/DynamicVideo';
import Static404 from './sections/Static404';
import StaticArticle from './sections/StaticArticle';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticCollection from './sections/StaticCollection';
import StaticCollectionList from './sections/StaticCollectionList';
import StaticHeader from './sections/StaticHeader';
import StaticPage from './sections/StaticPage';
import StaticPageContact from './sections/StaticPageContact';
import StaticProduct from './sections/StaticProduct';
import StaticSearch from './sections/StaticSearch';

const scriptsEl = document.querySelector('[data-scripts]');
const scripts = JSON.parse(scriptsEl.innerHTML);

export default class Atlantic {
  constructor() {
    this.el = document.body;

    const sections = new ShopifySectionsManager();

    sections.register('dynamic-blog', section => new DynamicBlog(section));
    sections.register('dynamic-collection', section => new DynamicCollection(section));
    sections.register('dynamic-instagram', section => new DynamicInstagram(section));
    sections.register('dynamic-product', section => new DynamicProduct(section));
    sections.register('dynamic-slideshow', section => new DynamicSlideshow(section));
    sections.register('dynamic-twitter', section => new DynamicTwitter(section));
    sections.register('dynamic-video', section => new DynamicVideo(section));
    sections.register('static-404', section => new Static404(section));
    sections.register('static-article', section => new StaticArticle(section));
    sections.register('static-blog', section => new StaticBlog(section));
    sections.register('static-cart', section => new StaticCart(section));
    sections.register('static-collection', section => new StaticCollection(section));
    sections.register('static-collection-list', section => new StaticCollectionList(section));
    sections.register('static-header', section => new StaticHeader(section));
    sections.register('static-page', section => new StaticPage(section));
    sections.register('static-page-contact', section => new StaticPageContact(section));
    sections.register('static-product', section => new StaticProduct(section));
    sections.register('static-search', section => new StaticSearch(section));
    sections.register('pxs-map', section => new PxsMap(section));

    rimg.init();

    if ($('body').hasClass('template-gift-card')) {
      $script(scripts.qrcode, () => {
        this.templateGiftCard = new TemplateGiftCard({ el: this.el });
      });
    }

    if ($('body').hasClass('template-customers-login')) {
      this.templateAccountLogin = new TemplateAccountLogin({ el: this.el });
    }

    if ($('body').hasClass('template-customers-addresses')) {
      this.templateAccountAddresses = new TemplateAccountAddresses({ el: this.el });
    }

    if ($('body').hasClass('template-password')) {
      this.templatePassword = new TemplatePassword({ el: this.el });
    }

    $('.field').on('focus', this.removeErrors.bind(this));
  }

  removeErrors(e) {
    const field = $(e.currentTarget, this.el);
    return field.removeClass('error');
  }
}

$script([
  scripts.countries,
  scripts.currencies,
  scripts.customer_area,
  scripts.jquery_api,
  scripts.plugins,
  scripts.shopify_common,
], () => {
  $script([
    scripts.jquery_cart,
    scripts.jquery_currencies,
  ], () => new Atlantic());
});
